module.exports = __webpack_public_path__ + "static/media/feature-split-image-02.785e07fe.png";